import { TransactionData } from '../../domain/stream/transaction/TransactionDomains';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { CaseSettings } from '../../domain/case/CaseDomains';
import { ColumnProps } from 'primereact/column';

export type CaseActions =
  | 'CHANGE_CURRENT_TRANSACTION_DATA'
  | 'CHANGE_TRANSACTION_HISTORY_DATA'
  | 'CHANGE_CASE_COLUMNS'
  | 'CHANGE_CURRENT_CASE_SETTINGS'
  | 'CHANGE_CASE_SETTINGS'
  | 'CHANGE_CASE_DATA_LOADING'
  | 'CLEAR_TRANSACTION_PAGE'
  | 'CHANGE_CONTAINER_LOADING'
  | 'CHANGE_LIST_COMPONENT_LOADING'
  | 'CHANGE_LIST_DATA_LOADING'
  | 'CHANGE_TRANSACTION_COUNT_LOADING';

export const changeCurrentTransactionData = (payload: TransactionData | null) =>
  ({
    type: 'CHANGE_CURRENT_TRANSACTION_DATA',
    payload,
  }) as ReduxBaseAction<TransactionData | null, CaseActions>;

export const changeTransactionHistoryData = (payload: TransactionData[]) =>
  ({
    type: 'CHANGE_TRANSACTION_HISTORY_DATA',
    payload,
  }) as ReduxBaseAction<TransactionData[], CaseActions>;

export const changeCurrentSettings = (payload: CaseSettings | null) =>
  ({
    type: 'CHANGE_CURRENT_CASE_SETTINGS',
    payload,
  }) as ReduxBaseAction<CaseSettings | null, CaseActions>;

export const changeCaseSettings = (payload: CaseSettings[]) =>
  ({
    type: 'CHANGE_CASE_SETTINGS',
    payload,
  }) as ReduxBaseAction<CaseSettings[], CaseActions>;

export const changeCaseDataLoading = (payload: boolean) =>
  ({
    type: 'CHANGE_CASE_DATA_LOADING',
    payload,
  }) as ReduxBaseAction<boolean, CaseActions>;

export const changeCaseColumns = (payload: Record<string, ColumnProps[]>) =>
  ({
    type: 'CHANGE_CASE_COLUMNS',
    payload,
  }) as ReduxBaseAction<Record<string, ColumnProps[]>, CaseActions>;

export const changeContainerLoading = (payload: boolean) =>
  ({
    type: 'CHANGE_CONTAINER_LOADING',
    payload,
  }) as ReduxBaseAction<boolean, CaseActions>;

export const changeListComponentLoading = (payload: boolean) =>
  ({
    type: 'CHANGE_LIST_COMPONENT_LOADING',
    payload,
  }) as ReduxBaseAction<boolean, CaseActions>;

export const changeListDataLoading = (payload: boolean) =>
  ({
    type: 'CHANGE_LIST_DATA_LOADING',
    payload,
  }) as ReduxBaseAction<boolean, CaseActions>;

export const changeTransactionCountLoading = (payload: boolean) =>
  ({
    type: 'CHANGE_TRANSACTION_COUNT_LOADING',
    payload,
  }) as ReduxBaseAction<boolean, CaseActions>;

export const clearTransactionPage = () =>
  ({
    type: 'CLEAR_TRANSACTION_PAGE',
  }) as ReduxBaseAction<null, CaseActions>;
